import { styled } from "@mui/material/styles"

export const Name = styled("div")({
  fontWeight: 700
})
